import React, { Component } from 'react';
import MapContacts from './MapContacts';
import { DTour } from './3DTour';
import { FormGroup } from 'reactstrap';

export class Contacts extends Component {
  displayName = Contacts.name;

  render() {
    return (
      <div>
        <h1>Контакты</h1>
        <FormGroup>
          <b>Контактные телефоны</b>
          <a className='contacts-phone' href='tel:+79012733515'>+7-901-273-35-15</a>
          <a className='contacts-phone' href='tel:+79397767402'>+7-939-776-74-02</a>
        </FormGroup>
        <FormGroup>
          <b>Наш адрес</b><br />
          г. Ярославль, ул. Академика Колмогорова, д.22
        </FormGroup>
        <FormGroup>
          <h2>3D Тур</h2>
          <DTour />
        </FormGroup>
        <FormGroup>
          <h2>Мы на карте</h2>
          <MapContacts />
        </FormGroup>
      </div>
    );
  }
}
